import React, { useMemo } from "react"

import { connect } from "scrivito"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"
import { ChipVariant } from "shared/ui/chip/Chip"
import { Tag, Tags } from "shared/ui/tags/Tags"

interface InstallationReferenceTagsProps {
  installationReferenceObj: InstallationReferenceObj
}

export function InstallationReferenceTagsComponent({
  installationReferenceObj
}: InstallationReferenceTagsProps) {
  const productTag: Tag | null = useMemo(
    () =>
      installationReferenceObj.get("product")
        ? {
            key: installationReferenceObj.get("product")?.id() as string,
            title: installationReferenceObj
              .get("product")
              ?.get("titleShort") as string
          }
        : null,
    [installationReferenceObj.get("product")]
  )

  const tags = useMemo(() => (productTag ? [productTag] : []), [productTag])

  return <Tags tags={tags} chipStyle={ChipVariant.INFO} />
}

export const InstallationReferenceTags = React.memo(
  connect(InstallationReferenceTagsComponent)
)
